import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';
import { add_admin } from '../../../../api/API';

const useStyles = makeStyles(theme => ({
    root: {},

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        },

    },

    flexend: {
        justifyContent: 'flex-end',
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));

export default function From(props) {

    const { profile, className, ...rest } = props;

    const classes = useStyles();

    const [passwordError, setPasswordError] = useState({
        isError: false,
        message: ''
    });
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [values, setValues] = useState({
        // firstName: profile.firstName,
        // lastName: profile.lastName,
        // email: profile.email,
        // phone: profile.phone,
        // state: profile.state,
        // country: profile.country,
        // isPublic: profile.isPublic,
        // canHire: profile.canHire
    });

    const history = useHistory();

    const positions = ['Superadmin', 'Admin'];

    const checkPassword = (password) => {
        let check_length = new RegExp("(?=.{6,})");
        let check_number = new RegExp("(?=.*[0-9])");
        let check_special = new RegExp("(?:.*[!@#$%^&*()+\'\"]+.*)");

        if (!check_length.test(password)) {
            setPasswordError({
                isError: true,
                message: "Password must be at least 6 characters or longer"
            });
            return false;
        }
        if (!check_number.test(password)) {
            setPasswordError({
                isError: true,
                message: "Password must be at contain at least 1 number"
            });
            return false;
        }
        if (!check_special.test(password)) {
            setPasswordError({
                isError: true,
                message: "Password must be at least 1 special character"
            });
            return false;
        }
        setPasswordError({
            isError: false,
            message: "All Good"
        });

        return true;
    }
    const handleChange = event => {
        event.persist();

        if (event.target.name == "password") {
            checkPassword(event.target.value);
        }

        setValues({
            ...values,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        });
    };

    // const handleSubmit = event => {
    // event.preventDefault();
    // setOpenSnackbar(true);
    // history.push("/admin");

    // };

    const handleSubmit = async event => {

        event.preventDefault();

        var role_id = 1;

        if (values.position == 'Admin') {
            role_id = 2;
        }

        if (!checkPassword(values.password)) {
            return;
        }

        if (values.password != values.password2) {
            alert("Passwords do not match");
            return;
        }

        if ((values.password) == "") {
            alert("Please enter a password");
            return;
        }


        // alert(values.position);
        const postparam = {
            username: values.email,
            password: values.password,
            name: values.name,
            email: values.email,
            contact: values.contact,
            role_id: role_id,
        };

        let data = await add_admin(postparam);
        if (data.status) {
            setOpenSnackbar(true);
            history.push("/admin");
        } else {
            alert(data.message);
        }
    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };


    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <form onSubmit={handleSubmit}>
                <CardHeader title="Create New Admin" />
                <Divider />
                <CardContent>
                    <Grid
                        container
                        spacing={4}
                    >

                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Name"
                                name="name"
                                onChange={handleChange}
                                required
                                value={values.name}
                                variant="outlined"
                            />
                        </Grid>


                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Email Address"
                                name="email"
                                onChange={handleChange}
                                required
                                value={values.email}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Contact"
                                name="contact"
                                onChange={handleChange}
                                required
                                value={values.contact}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Password"
                                required
                                name="password"
                                onChange={handleChange}
                                type="password"
                                value={values.password}
                                variant="outlined"
                                error={passwordError.isError}
                                helperText={passwordError.message}
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Confirm Password"
                                required
                                name="password2"
                                onChange={handleChange}
                                type="password"
                                value={values.password2}
                                variant="outlined"
                            />
                        </Grid>


                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Position"
                                name="position"
                                onChange={handleChange}
                                select
                                // eslint-disable-next-line react/jsx-sort-props
                                SelectProps={{ native: true }}
                                required
                                value={values.position}
                                variant="outlined"
                            >
                                {positions.map(position => (
                                    <option
                                        key={position}
                                        value={position}
                                    >
                                        {position}
                                    </option>
                                ))}
                            </TextField>
                        </Grid>




                    </Grid>
                </CardContent>
                <Divider />
                <CardActions className={classes.flexend}>
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: "black"
                        }}
                        onClick={() => {
                            history.goBack();
                        }}
                    >
                        <CancelIcon className={classes.leftIcon} />
                        Cancel
                </Button>
                    <Button
                        className={classes}
                        type="submit"
                        variant="contained"

                    >
                        <SaveIcon className={classes.leftIcon} />
                        Save Changes

                </Button>
                </CardActions>
            </form>
            {/* <SuccessSnackbar
            onClose={handleSnackbarClose}
            open={openSnackbar}
            /> */}
        </Card>
    )
}

